import { createReducer, on } from '@ngrx/store';
import * as loaderActions from '../actions/loader.actions';

export interface LoaderState {
  show: boolean;
}

export const initialState: LoaderState = {
  show: false,
};

export const loaderReducer = createReducer(
  initialState,
  on(loaderActions.showLoader, (state) => ({
    ...state,
    show: true,
  })),
  on(loaderActions.hideLoader, (state) => ({
    ...state,
    show: false,
  }))
);
